import { useState } from 'react';
import type { CSSProperties } from 'react';
import { getSignedUrl, humanSize } from './storage';
import { useDialog } from '../ui/Dialogs';
import type { Attachment } from './types';

function iconForMime(mime: string | null | undefined): string {
  const m = mime ?? '';
  if (m.startsWith('image/')) return '🖼';
  if (m.startsWith('video/')) return '🎬';
  if (m.startsWith('audio/')) return '🎵';
  if (m.includes('pdf')) return '📕';
  if (m.includes('zip') || m.includes('compressed')) return '🗜';
  if (m.includes('word') || m.includes('document')) return '📘';
  if (m.includes('excel') || m.includes('sheet')) return '📗';
  if (m.includes('presentation') || m.includes('powerpoint')) return '📙';
  return '📄';
}

interface Props {
  attachment: Attachment;
}

export default function AttachmentCard({ attachment }: Props) {
  const [busy, setBusy] = useState(false);
  const { alert } = useDialog();

  const handleDownload = async () => {
    setBusy(true);
    try {
      const url = await getSignedUrl(attachment.storage_path, 3600);
      window.open(url, '_blank', 'noopener,noreferrer');
    } catch (err) {
      const msg = err instanceof Error ? err.message : String(err);
      alert({ title: 'No se pudo descargar', message: msg });
    } finally {
      setBusy(false);
    }
  };

  const btnStyle: CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 10,
    background: 'rgba(255,255,255,0.7)',
    border: '1px solid currentColor',
    borderRadius: 10,
    padding: '8px 12px',
    cursor: busy ? 'wait' : 'pointer',
    color: 'inherit',
    fontSize: 13,
    marginTop: 6,
    maxWidth: 280,
  };

  return (
    <button type="button" onClick={handleDownload} disabled={busy} style={btnStyle}>
      <span style={{ fontSize: 18 }}>{iconForMime(attachment.mime_type)}</span>
      <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', minWidth: 0 }}>
        <span style={{
          fontWeight: 600,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: 220,
        }}>{attachment.file_name}</span>
        <span style={{ fontSize: 11, opacity: 0.7 }}>
          {humanSize(attachment.size_bytes)} · {busy ? 'Abriendo…' : 'Descargar'}
        </span>
      </span>
    </button>
  );
}
